import {TFoot} from './styles'

export const TableFoot = ({children}) => {

    return(
        <TFoot>
            {children}
        </TFoot>
    )
}